/**
 * グローバル排他再生アービター。
 *
 * アプリ内で同時に再生されるオーディオを 1 つに保つ。
 * Context Provider ではなくモジュールシングルトンとすることで、
 * ルートへの組み込みなしにモーダル・ポータルをまたいで排他が効く。
 *
 * 使い方: 再生開始時に `claimPlayback(token, pauseFn)` を呼ぶ。
 * 別のプレイヤーが claim した時点で、前のプレイヤーの pauseFn が呼ばれる。
 */

interface PlaybackClaim {
  token: symbol;
  pause: () => void;
}

let currentClaim: PlaybackClaim | null = null;

/** 再生権を取得する。既存の再生があれば停止させる */
export function claimPlayback(token: symbol, pause: () => void): void {
  if (currentClaim && currentClaim.token !== token) {
    try {
      currentClaim.pause();
    } catch {
      // 破棄済みプレイヤーの pause 失敗は無視
    }
  }
  currentClaim = { token, pause };
}

/** 再生権を手放す（アンマウント時等。自分が保持している場合のみ解放） */
export function releasePlayback(token: symbol): void {
  if (currentClaim?.token === token) {
    currentClaim = null;
  }
}
